export enum AgentEnum {
   ADDAPPAREDIRECTIONDESIGN="ADD-APPAREL DIRECTION & DESIGN",
   ASMARASMARAAPPARELSINDIAPVTLTD="ASMAR-ASMARA APPARELS INDIA PVT LTD",
   ATLASATLAST="ATLAS-ATLAST",
   CACA="C&A-C&A",
   CELSACELSAEFRONIAPPLETEX="CELSA-CELSA EFRONI (APPLE TEX)",
   GAPGAP="GAP-GAP",
   IMPULIMPULSE="IMPUL-IMPULSE",
   INDIINDITEXINDIAOFFICE="INDI-INDITEX INDIA OFFICE",
   KOLOUKOLOURCONCEPT="KOLOU-KOLOUR CONCEPT",
   LFUNGLIFUNGINDIA="LFUNG-LI & FUNG INDIA",
   MONDIMONDIAL="MONDI-MONDIAL",
   NADIRECTCUSTOMER="NA-DIRECT CUSTOMER",
   OTTOOTTOASIA="OTTO-OTTO ASIA",
   SARASARALEE="SARA-SARA LEE",
   SDACSDAPPARELCONSULTANTSPVTLTD="SDAC-S.D. APPAREL CONSULTANTS PVT LTD",
   SEARSSEARSBUYINGSERVICESINC="SEARS-SEARS BUYING SERVICES INC",
   SILVESILVERCRUST="SILVE-SILVER CRUST",
   TOMMYTOMMYHILFIGERINDIAOFFICE="TOMMY-TOMMY HILFIGER INDIA OFFICE",
   TRIBUTRIBURG="TRIBU-TRIBURG",
   TSSTEXTILESOURCINGSERVICES="TSS-TEXTILE SOURCING SERVICES",
   VANITVANITYFAIR="VANIT-VANITY FAIR",
   VIAMOVIAMODA="VIAMO-VIA MODA",
   WALMAWALMARTINDIASOURCING="WALMA-WALMART INDIA SOURCING",
   WECAWILLIAMECONNORS  = 'WECA-WILLIAM E CONNORS',
}
